"use client"

import { useState } from "react"

interface LiteYouTubeProps {
  videoId: string
  title: string
  onPlay?: () => void
}

export function LiteYouTube({ videoId, title, onPlay }: LiteYouTubeProps) {
  const [loaded, setLoaded] = useState(false)

  const src = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&autoplay=1`
  const thumbnailSrc = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`

  return (
    <div
      className="relative aspect-video cursor-pointer bg-gradient-to-br from-gray-900 to-black"
      onClick={() => {
        if (!loaded) {
          onPlay?.()
          setLoaded(true)
        }
      }}
      style={{ 
        minHeight: '1px',
        contain: 'layout style paint',
        willChange: 'auto'
      }}
    >
      {!loaded ? (
        <>
          {/* Miniatura servida por el CDN de YouTube (i.ytimg.com) en la
              fachada que evita cargar el iframe. `next/image` obligaría a
              declarar el host en `remotePatterns` y a pasar por el optimizador
              una imagen que YouTube ya sirve optimizada y cacheada. */}
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={thumbnailSrc}
            alt={title}
            loading="lazy"
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-600 shadow-lg">
              <div className="ml-1 border-l-8 border-y-[8px] border-l-white border-y-transparent" />
            </div>
          </div>
        </>
      ) : (
        <iframe
          src={src}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="h-full w-full"
        />
      )}
    </div>
  )
}
